export const RADIUS = 150;
export const LINE_WIDTH = 10;
export const MAIN_COLOR = '#6610F2';
export const SECONDARY_COLOR = '#E0E0E0';
export const BACKGROUND = '#fff';
